import React, { useState, useEffect } from "react";
import { Container, Row, Button, Col } from "react-bootstrap";
import Particle from "../Particle";
import cv from "../../Assets/Rehman_Resume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(window.innerWidth);
  const [numPages, setNumPages] = useState(1);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const renderPdfPages = () => {
    return Array.from({ length: numPages }, (_, index) => (
      <Document
        file={cv}
        key={`page_${index + 1}`}
        onLoadSuccess={onDocumentLoadSuccess}
        className="d-flex justify-content-center"
      >
        <Page pageNumber={index + 1} scale={width > 786 ? 1.4 : 0.7} renderAnnotationLayer={false} />
      </Document>
    ));
  };

  return (
    <div>
      <Container fluid className="resume-section px-4 py-5">
        <Particle />
        <Row className="sticky justify-content-center my-4">
          <Col xs="auto">
            <Button variant="primary" href={cv} download="Rehman_Detailed_CV.pdf" className="download-btn">
              <AiOutlineDownload />
              &nbsp;Download CV
            </Button>
          </Col>
        </Row>
        <Row className="resume-content">{renderPdfPages()}</Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
